<template>
  <div class="root">
    <v-card
      class="card"
      outlined
      :ripple="!isNotMobile"
      @click="navTo"
    >
      <div class="root-container">
        <div class="img-container d-flex justify-center mb-3 mb-md-0">
          <img width="40" height="31" alt="" :src="image" />
        </div>
        <div class="details-container px-0 pl-md-6">
          <div class="flex flex-col">
            <v-list-item-title class="card__title text-center text-md-left">
              {{ title }}
            </v-list-item-title>
            <v-card-text class="card__description pa-0 d-sm-none d-none">
              {{ description }}
            </v-card-text>
          </div>
          <v-card-actions
            class="
              pl-md-0
              p0-0
              text-sm-center text-md-left
              justify-center justify-md-start
              d-none d-md-block
            "
          >
            <component :is="renderUrl(url)" v-bind="currentUrlProperties">
              <v-btn
                class="card__btn rounded-0 mt-1 w-sm-100"
                depressed
                color="primary"
                height="23"
                width="97"
              >
                {{ buttonText || 'View' }}
              </v-btn>
            </component>
          </v-card-actions>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ['title', 'description', 'icon', 'url', 'buttonText'],
  data() {
    return {
      image: '',
      isNotMobile: true,
      currentUrlProperties: {},
    };
  },
  computed: {
    ...mapGetters(['windowWidth']),
  },
  created() {
    this.image = require('../../assets/' + this.icon);
    if(window.innerWidth < 960){
      this.isNotMobile = false;
    }
  },
  methods: {
    navTo() {
      if (window.innerWidth < 960) {
        this.$router.push(this.url);
      }
    },
    renderUrl (url) {
      const isExternal = url?.startsWith('http');
      this.currentUrlProperties = isExternal ? {
        href: url,
        target: '_blank',
      } : { to: url };
      return  isExternal ? 'a' : 'router-link';
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  height: 100%;
}
.root-container {
  display: flex;
  height: 100%;
}
.card:before {
  background: none;
}
.card {
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  border: 0;
  height: 100%;
  padding: 24px 16px 22px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: text;
  @media (max-width: 600px) {
    padding: 8px;
  }
}
.card .card__title {
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: var(--v-primary-base);
  margin-top: 6px;
  margin-bottom: 4px;

  @media (max-width: 1264px) {
    margin-top: -8px;
  }
}
.card .card__description {
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  margin-bottom: 8px;
  min-height: 50px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #7b7d7a;
  cursor: text;
  @media (min-width: 960px) {
    display: -webkit-box !important;
  }
}
.card .card__btn {
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: 0.1px;
  text-transform: capitalize;
}
.details-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (max-width: 600px) {
  .card .card__title {
    font-size: 12px;
  }
}
@media screen and (max-width: 959px) {
  .root-container {
    flex-direction: column;
  }
  .details-container {
    flex: unset;
    width: 100%;
  }
}
@media screen and (max-width: 1264px) {
  .card {
    height: 100%;
  }
}
</style>
